<mat-card>
    <mat-card-content>
        <mx-thumbnail [defaultThumbnailClass]="defaultThumbnailClass" [thumbnailUrl]="thumbnailUrl"></mx-thumbnail>
    </mat-card-content>
    <mat-card-actions>
        <mx-button [buttonModel]="uploadThumbBtn"></mx-button>
        <mx-button *ngIf="hasReset" [buttonModel]="resetThumbBtn"></mx-button>
    </mat-card-actions>
</mat-card>
